import { render } from "./JobDescription.vue?vue&type=template&id=e15a7e8a&scoped=true"
import script from "./JobDescription.vue?vue&type=script&lang=js"
export * from "./JobDescription.vue?vue&type=script&lang=js"

import "./JobDescription.vue?vue&type=style&index=0&id=e15a7e8a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e15a7e8a"]])

export default __exports__